import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "@material-ui/core/Button";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { getOptions } from "../../service/api/option";

const useStyles = makeStyles((theme) => ({
  scrollbar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 57,
    marginBottom: 10,
    maxWidth: "95vw",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      marginBottom: 40,
    },
  },
  right: {
    display: "flex",
    flexDirection: "row",
    width: "90%",
    [theme.breakpoints.only("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginTop: 5,
    },
  },
  left: {
    minWidth: 90,
    marginLeft: 10,
    textAlign: "left",
    cursor: "context-menu",
    [theme.breakpoints.down("xs")]: {
      cursor: "pointer",
    },
  },
  gridList: {
    overflowX: "auto",
    scrollbarWidth: "none",
    display: "flex",
    flexDirection: "row",
  },
  listItem: { paddingLeft: 5, paddingRight: 5 },
  singleButton: {
    border: "none",
    height: 50,
    color: "#FFFFFF",
    background: "#457B9D",
    textTransform: "none",
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: {
      height: 35,
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "inline-block",
      minWidth: "15vw",
    },
    [theme.breakpoints.up("sm")]: {
      width: 200,
    },
  },
  phoneFocusDiv: {
    margin: "auto",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
  },
  phoneFocusButton: {
    border: "none",
    height: 60,
    color: "#FFFFFF",
    backgroundColor: "#1D3557",
    textTransform: "none",
    opacity: 1.0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  focusedTitle: {
    textAlign: "center",
  },
}));

const NestedCategoryHorizontalScroll = ({
  parent,
  parentID,
  parentTitle,
  childID,
  childTitle,
  getOpChildID,
  selectedParent,
  setSelectedParent,
  selectedChild,
  setSelectedChild,
  child,
  setChild,
  focusParent,
  setFocusParent,
  focusChild,
  setFocusChild,
  hideFocusParent,
  setHideFocusParent,
  hideFocusChild,
  setHideFocusChild,
  width,
  isWidthSm,
}) => {
  const classes = useStyles();
  const isFirefox = window.navigator.userAgent.indexOf("Firefox") !== -1;

  //scrollBehavior --> smooth = sliding; auto = instant jump
  // eg. [A,B,C,Z] --> [Z',A,B,C,Z,A']  Z' --> pseudoLast || A' --> pseudoFirst
  const carousel = (option) => {
    let temp = [...option];
    if (isWidthSm && option.length !== 0) {
      let tempFirstItem = { id: "pseudoFirst", name: option[0].name };
      let tempLastItem = {
        id: "pseudoLast",
        name: option[option.length - 1].name,
      };
      temp.unshift(tempLastItem);
      temp.push(tempFirstItem);
    }
    return temp;
  };

  //if mobile view, make it carousel array type; else remain the same
  const parentList = isWidthSm ? carousel(parent) : parent;
  const childList = isWidthSm ? carousel(child) : child;

  const scrollToView = (optionId) => {
    let element = document.getElementById(optionId);
    if (element !== null)
      element.scrollIntoView({
        behavior: "auto",
        inline: "center",
        block: "nearest",
      });
  };

  //update chosen element and scroll to the element
  const updateChosen = (id, chosenNode, options) => {
    let scroller = document.getElementById(id);
    if (id === parentID) {
      setSelectedParent(chosenNode.id);
      setFocusParent(chosenNode.name);
    } else {
      setSelectedChild(chosenNode.id);
      setFocusChild(chosenNode.name);
    }
    if (isWidthSm) {
      //determine the distance to be scrolled
      let total = 0;
      if (options && scroller && document.getElementById(options[0].id)) {
        for (let i = 0; i < options.length; i++) {
          if (options[i + 1] === chosenNode) {
            //leave some space at the left side for scrolling/dragging
            total += document.getElementById(options[i].id).clientWidth / 1.5;
            break;
          }
          //this element can be completely hidden
          else total += document.getElementById(options[i].id).clientWidth;
        }
        scroller.scrollTo(total, 0);
        if (!isFirefox) scroller.style.scrollBehavior = "smooth"; //make scroller back to sliding
      }
    } else scrollToView(chosenNode.id); //desktop view
  };

  //used for phone view (initiate the dark blue div covering the list)
  const setFocus = (id) => {
    if (id === parentID) {
      if (selectedParent === "" && parent.length > 0) {
        smoothScroll(id, parent[0], parentList);
      }
    } else {
      if (selectedChild === "" && child.length > 0) {
        smoothScroll(id, child[0], childList);
      }
    }
  };

  // helper function to identify category with subcategories
  const categoriesToLocalCategories = (categories) => {
    const tmp = JSON.parse(JSON.stringify(categories));
    const subcategoryMap = {}; // to process the parent category - subcategory name
    // find all the subcategories
    tmp.forEach((x) => {
      x.subcategories = categories
        .filter((s) => s.dependent === x.id)
        .map((sub) => ({
          id: sub.id,
          optionId: sub.id,
          name: sub.name, // mutate name to include parent
        }));
      // add into subcategory map for processing later
      x.subcategories.forEach((ss) => (subcategoryMap[ss.id] = x.name));
    });
    // for each category, modify name if is subcategory
    tmp.forEach((x) => {
      if (!!subcategoryMap[x.id]) {
        x.name = subcategoryMap[x.id] + " - " + x.name;
      }
    });
    // reformat all the categories
    return tmp.map((t) => ({
      id: t.id,
      optionId: t.id,
      name: t.name,
      subcategories: t.subcategories,
    }));
  };

  // called when selected parent is changed
  useEffect(() => {
    // reset selected child
    setSelectedChild("");
    // get child options
    if (!!selectedParent) {
      // special case, for opChildID of investCategory, check subcategories
      if (getOpChildID === "investCategory") {
        getOptions(getOpChildID, "", "", selectedParent).then((data) => {
          setChild(
            categoriesToLocalCategories(data).filter(
              (s) => s.subcategories.length === 0
            )
          );
          if (!!data[0] && isWidthSm) {
            smoothScroll(childID, data[0], isWidthSm ? carousel(data) : data);
          }
        });
      } else {
        getOptions(getOpChildID, selectedParent).then((data) => {
          setChild(data);
          if (!!data[0] && isWidthSm) {
            smoothScroll(childID, data[0], isWidthSm ? carousel(data) : data);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedParent]);

  useEffect(() => {
    scrollToView(selectedParent);
    setTimeout(() => {
      if (!!selectedParent && selectedChild === "" && !!child[0] && isWidthSm) {
        //when user selects parent only and resizes the window
        updateChosen(child, child[0], childList);
      } else {
        scrollToView(selectedChild);
      }
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  //slide a little and instant jump
  const fakeScroll = (direction, id, chosenNode, options) => {
    let scroller = document.getElementById(id);
    scroller.scrollBy(direction === "right" ? 50 : -50, 0); //slide

    setTimeout(() => {
      scroller.style.scrollBehavior = "auto"; //jump
      updateChosen(id, chosenNode, options);
    }, 80); //time spare for sliding before instant jump
  };

  //for normal behavior, slide as usual
  const smoothScroll = (id, chosenNode, options) => {
    if (!isFirefox && document.getElementById(id))
      document.getElementById(id).style.scrollBehavior = "smooth";
    updateChosen(id, chosenNode, options);
  };

  const clickNext = (id) => {
    if (isWidthSm) {
      if (id === parentID) {
        if (focusParent !== parent[parent.length - 1].name) {
          //normal behavior
          for (let i = 0; i < parent.length; i++)
            if (parent[i].id === selectedParent) {
              smoothScroll(id, parent[i + 1], parentList);
              break;
            }
        }
        //when last element is selected and user clicks next
        else fakeScroll("right", id, parent[0], parentList);
      } else {
        if (focusChild !== child[child.length - 1].name) {
          //normal behavior
          for (let i = 0; i < child.length; i++)
            if (child[i].id === selectedChild) {
              smoothScroll(id, child[i + 1], childList);
              break;
            }
        }
        //when last element is selected and user clicks next
        else fakeScroll("right", id, child[0], childList);
      }
    } else document.getElementById(id).scrollLeft += 300;
  };

  const clickBack = (id) => {
    if (isWidthSm) {
      if (id === parentID) {
        if (focusParent !== parent[0].name) {
          //normal behavior
          for (let i = 0; i < parent.length; i++)
            if (parent[i].id === selectedParent) {
              smoothScroll(id, parent[i - 1], parentList);
              break;
            }
        }
        //when first element is selected and user clicks back
        else fakeScroll("left", id, parent[parent.length - 1], parentList);
      } else {
        if (focusChild !== child[0].name) {
          //normal behavior
          for (let i = 0; i < child.length; i++)
            if (child[i].id === selectedChild) {
              smoothScroll(id, child[i - 1], childList);
              break;
            }
        }
        //when first element is selected and user clicks back
        else fakeScroll("left", id, child[child.length - 1], childList);
      }
    } else document.getElementById(id).scrollLeft -= 300;
  };

  //when user clicks on the options from the horizontal list
  const handleClick = (id, option, options) => {
    //when user selects pseudoButton
    if (option.id.toString().includes("pseudo")) {
      if (option.id === "pseudoLast") {
        //scroll to the actual last element
        if (id === parentID) {
          fakeScroll("left", id, parent[parent.length - 1], parentList);
        } else {
          fakeScroll("left", id, child[child.length - 1], childList);
        }
      } else {
        //scroll to the actual first element
        if (id === parentID) {
          fakeScroll("right", id, parent[0], parentList);
        } else {
          fakeScroll("right", id, child[0], childList);
        }
      }
    }
    //normal behavior
    else smoothScroll(id, option, options);
  };

  const handleScroll = (id) => {
    if (id === parentID) setHideFocusParent(true);
    else setHideFocusChild(true);

    setTimeout(() => {
      if (id === parentID) setHideFocusParent(false);
      else setHideFocusChild(false);
    }, 400);
  };

  const checkDragging = (id, carouselOptions) => {
    let scroller = document.getElementById(id);
    let scrollLeft = document.getElementById(id).scrollLeft; //magnitude of scrolled distance to the right

    let passingDistance = scrollLeft + scroller.offsetWidth;

    let firstElementWidth = document.getElementById(carouselOptions[0].id)
      .offsetWidth;
    let lastElementWidth = document.getElementById(
      carouselOptions[carouselOptions.length - 1].id
    ).offsetWidth;

    //when first element is selected and user drags to the left
    if (scrollLeft < firstElementWidth / 2.5) {
      //scroll to the last
      fakeScroll(
        "left",
        id,
        carouselOptions[carouselOptions.length - 2],
        carouselOptions
      );
    } else {
      //normal dragging behavior
      if (passingDistance < scroller.scrollWidth - lastElementWidth / 3) {
        //chosenIndex: the element desired by user
        let chosenIndex = 0,
          totalWidth = 0,
          maxWidth = scrollLeft + scroller.offsetWidth / 2.5;
        for (let i = 0; i < carouselOptions.length; i++) {
          totalWidth += document.getElementById(carouselOptions[i].id)
            .clientWidth;
          if (totalWidth > maxWidth) {
            chosenIndex = i;
            break;
          }
        }
        if (chosenIndex === carouselOptions.length - 1) {
          //if accidentally caught pseudoFirst
          fakeScroll("right", id, carouselOptions[1], carouselOptions);
        } else {
          if (chosenIndex === 0) {
            //if accidentally caught pseudoLast
            fakeScroll(
              "left",
              id,
              carouselOptions[carouselOptions.length - 2],
              carouselOptions
            );
          } else {
            //normal behavior
            smoothScroll(id, carouselOptions[chosenIndex], carouselOptions);
          }
        }
      } else {
        //when the last element is selected and user drags to the right
        fakeScroll("right", id, carouselOptions[1], carouselOptions);
      }
    }
  };

  // render options
  const renderOptions = (title, options, id) => {
    // render options of the horizontal list
    return (
      <div className={`hideScrollbar ${classes.scrollbar}`}>
        <Typography variant="h4" className={classes.left}>
          {title}
        </Typography>
        <div className={classes.right}>
          <IconButton
            color="primary"
            aria-label="back"
            onClick={() => clickBack(id)}
            size={!!isWidthSm ? "small" : "medium"}
          >
            <KeyboardArrowLeftIcon />
          </IconButton>
          {isWidthSm ? ( //phone view
            <>
              <List //horizontal list
                id={id}
                className={`hideScrollbar ${classes.gridList}`}
                onScroll={() => handleScroll(id)}
                style={!isFirefox ? { scrollBehavior: "smooth" } : null}
                onTouchEnd={() => checkDragging(id, options)}
              >
                {options.map((option) => (
                  <>
                    <ListItem key={option.id} className={classes.listItem}>
                      <Button
                        variant="contained"
                        id={option.id}
                        value={option.id}
                        className={classes.singleButton}
                        style={{
                          minWidth: width / 2.5,
                          opacity:
                            (id === childID && hideFocusChild) ||
                            (id === parentID && hideFocusParent)
                              ? 1.0
                              : 0.6,
                          backgroundColor: "#457B9D",
                        }}
                        onClick={() => {
                          handleClick(id, option, options);
                        }}
                      >
                        <Typography variant="h5">{option.name}</Typography>
                      </Button>
                    </ListItem>
                  </>
                ))}
              </List>
              <div //the dark blue div that covers the list
                id={id.toString() + "Mobile"}
                className={classes.phoneFocusDiv}
                style={{
                  left: width / 2,
                  right: width / 2,
                  opacity:
                    (id === childID && hideFocusChild) ||
                    (id === parentID && hideFocusParent)
                      ? 0
                      : 1,
                }}
              >
                {setFocus(id)} {/*set the default category or label name*/}
                <div className={classes.phoneFocusButton}>
                  <div
                    className={classes.focusedTitle}
                    style={{ width: width / 2.5 }}
                  >
                    {id === parentID ? focusParent : focusChild}
                  </div>
                </div>
              </div>
            </>
          ) : (
            //desktop view
            <List
              id={id}
              className={`hideScrollbar ${classes.gridList}`}
              style={{ scrollBehavior: "smooth" }}
            >
              {options.map((option, index) => (
                <ListItem key={option.id} className={classes.listItem}>
                  <Button
                    variant="contained"
                    id={option.id}
                    value={option.id}
                    className={classes.singleButton}
                    style={{
                      backgroundColor:
                        option.id === selectedParent ||
                        option.id === selectedChild
                          ? "#1D3557"
                          : "#457B9D",
                      borderRadius:
                        index === 0
                          ? options.length === 1
                            ? "20px"
                            : "20px 0px 0px 20px"
                          : index === options.length - 1
                          ? "0px 20px 20px 0px"
                          : 0,
                    }}
                    onClick={() => handleClick(id, option, options)}
                  >
                    <Typography variant="h5">{option.name}</Typography>
                  </Button>
                </ListItem>
              ))}
            </List>
          )}
          <IconButton
            color="primary"
            aria-label="back"
            onClick={() => {
              clickNext(id);
            }}
            size={!!isWidthSm ? "small" : "medium"}
          >
            <KeyboardArrowRightIcon />
          </IconButton>
        </div>
      </div>
    );
  };
  return (
    <>
      {renderOptions(parentTitle, parentList, parentID)}
      {child.length !== 0
        ? renderOptions(childTitle, childList, childID)
        : null}
    </>
  );
};

export default NestedCategoryHorizontalScroll;
